import { useQuery } from "react-query";
import { itemStatusesApi, type ItemStatus } from "@/lib/api/item-statuses";

export const ITEM_STATUSES_QUERY_KEY = ["item-statuses"] as const;

export function useItemStatuses(options?: { enabled?: boolean }) {
  return useQuery<ItemStatus[]>(ITEM_STATUSES_QUERY_KEY, () => itemStatusesApi.getAll(), {
    staleTime: 60 * 60 * 1000, // Read-only, no invalidation needed
    enabled: options?.enabled ?? true,
  });
}
